import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button, Form, TimePicker, Select, message } from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import { saveOrUpdatePolicyGeneral } from '../../../../../services/policy';
import PageContainer from '../../../../CSIComponents/PageContainer';
import moment from 'moment';
import Loading from './../../../../Loading';
import commonStyles from './../../../../CSIComponents/index.module.css';

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any,
    setOperationType: void | any,
    detailData: any,
    supplier: string,
    propertyid: string,
    getPoliciesData: () => {},
    setPoliciesData: void | any,
    setPetsAllowType: void | any
}
const format = 'HH:mm';
const FormItem = Form.Item
const Option = Select.Option
const petsOptions = ['Pets Allowed', 'Pets Not Allowed', 'Assistive Animals Only', 'Pets by Arrangements', 'Pets for Free']
const GeneralDetail = (props: propsTypes) => {

    // const data = props?.detailData?.environmentalimpact?.general?.general || {}
    const [form] = Form.useForm()
    const [loadingFlag, setLoadingFlag] = useState(false)
    const [disableFlag, setDisableFlag] = useState(false)
    useEffect(() => {
        validateForm()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    const handleSuccessFun = () => {
        props.cancelEditable();
        props.setOperationType('view');
        props.setPoliciesData(null)
        props.getPoliciesData();
    }
    const validateForm = () => {
        form.validateFields().then(() => {
            setDisableFlag(false)
        }).catch(err => {
            err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
        });
    }
    const updateGeneral = () => {
        form.validateFields().then(values => {
            setLoadingFlag(true)
            const requestBody = {
                supplier: props.supplier,
                propertyId: props.propertyid,
                property: {
                    policies: {
                        general: {
                            generalid: values.generalid,
                            generallangid: values.generallangid,
                            description: values.description,
                            generalcancelpolicy: values.generalcancelpolicy,
                            generalguaranteepolicy: values.generalguaranteepolicy,
                            generaldepositpolicy: values.generaldepositpolicy,
                            checkintime: values.checkintime.format(format),
                            checkouttime: values.checkouttime.format(format),
                            guesttyperestriction: values.guesttyperestriction,
                            minguestage: values.minguestage,
                            maxchildage: values.maxchildage,
                            childrenstayfree: values.childrenstayfree,
                            freechildage: values.freechildage,
                            freechildrenperadult: values.freechildrenperadult,
                            roomguaranteelatearrival: values.roomguaranteelatearrival,
                            petsallowed: values.petsallowed,
                        }
                    }
                }
            }
            saveOrUpdatePolicyGeneral(requestBody).then(
                response => {
                    if (response.result.success) {
                        setLoadingFlag(false)
                        handleSuccessFun()
                    } else {
                        message.error({
                            content: response?.error[0]?.message
                        });
                        setLoadingFlag(false)
                    }
                }, err => {
                    setLoadingFlag(false)
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                    props.cancelEditable();
                    //props.setOperationType('view');
                    //handleSuccessFun()
                }
            )
        })
    }

    if (loadingFlag) return <Loading type="large" />
    return (
      <PageContainer>
        <Card 
        style={{ marginTop: -15, marginBottom: 60 }} 
        title='General'
        headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px' }}
        >
          <Form
            form={form}
            layout='vertical'
            initialValues={{
              generalid: props?.detailData?.policies?.general?.generalid,
              generallangid:
                props?.detailData?.policies?.general?.generallangid,
              description: props?.detailData?.policies?.general?.description,
              generalcancelpolicy:
                props?.detailData?.policies?.general?.generalcancelpolicy,
              generalguaranteepolicy:
                props?.detailData?.policies?.general?.generalguaranteepolicy,
              generaldepositpolicy:
                props?.detailData?.policies?.general?.generaldepositpolicy,
              checkintime: props?.detailData?.policies?.general?.checkintime
                ? moment(
                    props?.detailData?.policies?.general?.checkintime,
                    format,
                  )
                : undefined,
              checkouttime: props?.detailData?.policies?.general?.checkouttime
                ? moment(
                    props?.detailData?.policies?.general?.checkouttime,
                    format,
                  )
                : undefined,
              guesttyperestriction:
                props?.detailData?.policies?.general?.guesttyperestriction,
              minguestage: props?.detailData?.policies?.general?.minguestage,
              maxchildage: props?.detailData?.policies?.general?.maxchildage,
              childrenstayfree:
                props?.detailData?.policies?.general?.childrenstayfree,
              freechildage: props?.detailData?.policies?.general?.freechildage,
              freechildrenperadult:
                props?.detailData?.policies?.general?.freechildrenperadult,
              roomguaranteelatearrival:
                props?.detailData?.policies?.general?.roomguaranteelatearrival,
              petsallowed: props?.detailData?.policies?.general?.petsallowed,
            }}
            onValuesChange={validateForm}>
            <FormItem name='generalid' style={{ display: 'none' }}>
              <Input />
            </FormItem>
            <FormItem name='generallangid' style={{ display: 'none' }}>
              <Input />
            </FormItem>

            <Row gutter={24}>
              <Col span={18}>
                <FormItem
                  name='description'
                  label='Policy Description'
                  rules={[
                    {
                      max: 2000,
                      message:
                        'You have reached the max character length of 2000',
                    },
                  ]}>
                  <TextArea maxLength={2000} minRows={3} />
                </FormItem>
              </Col>
              <Col span={18}>
                <FormItem
                  name='generalcancelpolicy'
                  label='General Cancellation Description'
                  rules={[
                    {
                      max: 2000,
                      message:
                        'You have reached the max character length of 2000',
                    },
                  ]}>
                  <TextArea maxLength={2000} minRows={3} />
                </FormItem>
              </Col>
              <Col span={18}>
                <FormItem
                  name='generalguaranteepolicy'
                  label='General Guarantee Policy'
                  rules={[
                    {
                      max: 2000,
                      message:
                        'You have reached the max character length of 2000',
                    },
                  ]}>
                  <TextArea maxLength={2000} minRows={3} />
                </FormItem>
              </Col>
              <Col span={18}>
                <FormItem
                  name='generaldepositpolicy'
                  label='General Deposit Policy'
                  rules={[
                    {
                      max: 2000,
                      message:
                        'You have reached the max character length of 2000',
                    },
                  ]}>
                  <TextArea maxLength={2000} minRows={3} />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  name='checkintime'
                  label='Check-In Time'
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}>
                  <TimePicker
                    style={{ width: '100%' }}
                    allowClear={false}
                    format={format}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='checkouttime'
                  label='Check-Out Time'
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}>
                  <TimePicker
                    style={{ width: '100%' }}
                    allowClear={false}
                    format={format}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='guesttyperestriction'
                  label='Guest Type Restrictions'>
                  <Select allowClear showSearch>
                    <Option value='Adult Only'>Adult Only</Option>
                    <Option value='Couples Only'>Couples Only</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  name='minguestage'
                  label='Minimum Guest Age'
                  rules={[
                    {
                      pattern: /^\d*(\.\d*)?$/,
                      message: 'This field should be a number.',
                    },
                  ]}
                  extra={
                    <span className="blue-font">Integer Min 1</span>
                  }>
                  <Input />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='maxchildage'
                  label='Maximum Child Age'
                  rules={[
                    { required: true, message: 'This field is required' },
                    {
                      pattern: /^\d*(\.\d*)?$/,
                      message: 'This field should be a number.',
                    },
                  ]}>
                  <Input />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='childrenstayfree'
                  label='Children Stay Fee'
                  rules={[
                    { required: true, message: 'This field is required' },
                  ]}>
                  <Select allowClear showSearch>
                    <Option value='true'>Yes</Option>
                    <Option value='false'>No</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  name='freechildage'
                  label='Free Child Cut-Off Age'
                  rules={[
                    {
                      pattern: /^([1-9]\d|\d)$/,
                      message: 'This field should be a number',
                    },
                    //{pattern:/^-?\d*(\.\d*)?$/, message:"This field should be a number."}
                  ]}
                  extra={
                    <span className="blue-font">Integer 0-99</span>
                  }>
                  <Input />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='freechildrenperadult'
                  label='Number of Free Children Per Adult'
                  rules={[
                    {
                      pattern: /^\d*?$/,
                      message: 'This field should be a number',
                    },
                    //{pattern:/^-?\d*(\.\d*)?$/, message:"This field should be a number."}
                  ]}>
                  <Input />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name='roomguaranteelatearrival'
                  label='Room Guaranteed for Late Arrival'>
                  <Select allowClear showSearch>
                    <Option value='true'>Yes</Option>
                    <Option value='false'>No</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={5}></Col>
              <Col span={6}>
                <FormItem name='petsallowed' label='Pets'>
                  <Select allowClear showSearch
                    onChange={(value) => props.setPetsAllowType(value)}>
                    {petsOptions.map((item) => (
                      <Option value={item} key={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Card>
        <ActionButtonsBar
          onCancel={() => {
            props.cancelEditable()
            props.setOperationType('view')
          }}
          onSave={updateGeneral}
          disabledSave={disableFlag}
        />
      </PageContainer>
    )
}

export default GeneralDetail;



